module.exports = __webpack_public_path__ + "static/media/google-maps-icon.62dfaa4e.svg";